<!-- Breadcrumb -->
<div *ngIf="app?.isPlatformBrowserVar" class="breadcrumb-bar" data-aos="fade-in" data-aos-duration="800">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-md-8 col-12">
        <nav aria-label="breadcrumb" class="page-breadcrumb">
          <ol class="breadcrumb nav-family-font">
            <mat-icon class="home-icon" aria-hidden="false" aria-label="Example home icon">home</mat-icon>
            <li class="breadcrumb-item">
              <a [routerLink]="'/' + this?.app?.languageCode + '/home'">{{ "navigationBar.Home" | translate }}</a>
            </li>
            <!-- <i
              *ngIf="this.app?.getUserLanguage() == 'en'"
              class="fa fa-angle-right nav-font"
            ></i>
            <i
              *ngIf="this.app?.getUserLanguage() == 'ar'"
              class="fa fa-angle-left nav-font"
            ></i>
            <li class="breadcrumb-item active" aria-current="page">
              {{ "navigationBar.Services" | translate }}
            </li> -->
            <i *ngIf="this.app?.getUserLanguage() == 'en'" class="fa fa-angle-right nav-font"></i>
            <i *ngIf="this.app?.getUserLanguage() == 'ar'" class="fa fa-angle-left nav-font"></i>
            <li (click)="app?.mainRouteToSearchComponent()" class="breadcrumb-item active cursor-pointer"
              aria-current="page">
              {{ "navigationBar.Search Doctor" | translate }}
            </li>

            <i *ngIf="this.app?.getUserLanguage() == 'en'" class="fa fa-angle-right nav-font"></i>
            <i *ngIf="this.app?.getUserLanguage() == 'ar'" class="fa fa-angle-left nav-font"></i>
            <li class="breadcrumb-item active" aria-current="page">
              {{ "navigationBar.Doctor Profile" | translate }}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
</div>
<!-- /Breadcrumb -->

<!-- Page Content -->
<div class="content" *ngIf="app?.isPlatformBrowserVar">
  <div class="container">
    <!-- Doctor Widget -->


    <div class="row">
      <h1 *ngIf="textSectionTitle != null" data-aos="fade-up" data-aos-duration="800" class="px-3 bigTitle">
        {{textSectionTitle}}</h1>
      <div class="col-sm-12 col-md-12 col-lg-7 col-xl-7 justify-cent m-0" data-aos="fade-up" data-aos-duration="800">
        <div class="shadow-boxx card p-3">
          <div class="row">
            <div class="col-12">
              <div class="d-flex">
                <div class="d-in-block mr-15">
                  <a>
                    <img
                      title="{{doctorDetails?.fullName | splitStringToArEn}} - {{ doctorDetails?.speciality | splitStringToArEn }}"
                      class="w-h-forMap" [src]="app.getUserImage2(doctorDetails?.picture)"
                      alt="{{doctorDetails?.fullName | splitStringToArEn}} - {{ doctorDetails?.speciality | splitStringToArEn }}" />
                    <!-- <app-img-loader [className]="'doctorDetails'" [src]="doctorDetails?.picture"></app-img-loader> -->
                  </a>
                </div>

                <div class="d-in-block p-00">
                  <div class="">
                    <h2 class="doc-name-info mb-0">
                      {{ doctorDetails?.fullName | splitStringToArEn }}
                    </h2>
                    <h5 class="docSpachility mb-0">
                      {{ doctorDetails?.speciality | splitStringToArEn }}
                    </h5>
                    <div class="d-flex align-items-center" *ngIf="doctorDetails?.rate">
                      <!-- <div class="mb-1">{{doctorDetails?.rate | star}}</div> -->
                      <img class="star-icon" src="assets/img/star2.svg" alt="" />
                      <span class="mx-1 rateP">{{doctorDetails?.rate}}</span>
                    </div>
                    <div class="clinic-services mt-14">

                      <div *ngIf="doctorDetails?.hasMoreThan3Services == true">
                        <span class="doc-service mx-1 mb-2"
                          *ngFor="let docSRV of doctorDetails?.medicalServices | slice :0:3">{{
                          docSRV.name }}</span>
                        <span (click)="doctorDetails.hasMoreThan3Services = false"
                          class="serviceViewMoreBtn mx-1 mb-2 cursor-pointer">{{'Home.ViewMore'|translate}}</span>
                      </div>

                      <div *ngIf="!doctorDetails?.hasMoreThan3Services">
                        <span class="doc-service mx-1 mb-2" *ngFor="let docSRV of doctorDetails?.medicalServices">{{
                          docSRV.name }}</span>
                        <span *ngIf="doctorDetails?.hasMoreThan3Services == false"
                          (click)="doctorDetails.hasMoreThan3Services = true"
                          class="serviceViewMoreBtn mx-1 mb-2 cursor-pointer">{{'Home.ViewLess'|translate}}</span>
                      </div>



                      <!-- <div class="row" *ngIf="doctorDetails?.hasMoreThan4Insurances == true">
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-5 "
                          *ngFor="let work of doctorDetails?.companies | slice :0:5"
                          [ngClass]="this.app?.getUserLanguage() == 'en' ? 'borderEn' : 'borderAr'">
                          <p class="insuranceEn m-0">{{work?.englishName}}</p>
                          <p class="insuranceAr m-0">{{ work?.arabicName }}</p>
                        </div>
    
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-5">
                          <button (click)="doctorDetails.hasMoreThan4Insurances = false"
                            class="btn viewMoreBtn">{{'Home.ViewMore'|translate}}</button>
                        </div>
                      </div>
    
                      <div class="row" *ngIf="!doctorDetails?.hasMoreThan4Insurances">
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-5 "
                          *ngFor="let work of doctorDetails?.companies"
                          [ngClass]="this.app?.getUserLanguage() == 'en' ? 'borderEn' : 'borderAr'">
                          <p class="insuranceEn m-0">{{work?.englishName}}</p>
                          <p class="insuranceAr m-0">{{ work?.arabicName }}</p>
                        </div>
    
                        <div *ngIf="doctorDetails?.hasMoreThan4Insurances == false"
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-5">
                          <button (click)="doctorDetails.hasMoreThan4Insurances = true"
                            class="btn viewMoreBtn">{{'Home.ViewLess'|translate}}</button>
                        </div>
                      </div> -->


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="row font-13 mt-3">

                <div class="col-12 mb-3" *ngIf="doctorDetails?.languages">
                  <p class="m-0 text-blue">
                    <i class="fa fa-globe mx-1 text-blue font-16px"></i>
                    <!-- px-3 mx-1 -->
                    <span class="doc-lang mx-1" *ngFor="let item of doctorDetails?.languages; let last = last">
                      <span *ngIf="this?.app?.languageCode == 'en'">{{item.englishName}}<span
                          *ngIf="!last">,</span></span>
                      <span *ngIf="this?.app?.languageCode == 'ar'">{{item.arabicName}}<span
                          *ngIf="!last">،</span></span>
                    </span>
                  </p>
                </div>

                <div class="col-12 mb-3" *ngIf="doctorDetails?.location || doctorDetails?.address">
                  <p class="m-0">
                    <i class="fa fa-map-marker mx-10 text-blue font-16px"></i>
                    <span class="mx-1 locationPs">
                      <span
                        *ngIf="!doctorDetails?.location?.parentName && doctorDetails?.location?.name">{{doctorDetails?.location?.name}}<span
                          *ngIf="doctorDetails?.address"> - {{doctorDetails?.address}}</span></span>
                      <span *ngIf="doctorDetails?.location?.parentName">{{doctorDetails?.location?.parentName}} -
                        {{doctorDetails?.location?.name}}<span *ngIf="doctorDetails?.address"> -
                          {{doctorDetails?.address}}</span></span>
                      <span *ngIf="doctorDetails?.address && !doctorDetails?.location">{{doctorDetails?.address}}</span>
                    </span>
                  </p>
                </div>

                <div class="col-12 mb-3">
                  <p class="m-0">
                    <i class="fa fa-phone mx-10 text-blue callIcon"></i>
                    <!-- +({{doctorDetails?.mobileNumber |slice:0:3}})
                      0{{doctorDetails?.mobileNumber |
                      slice:3:doctorDetails?.mobileNumber.length}} -->
                    <!-- {{ "doctorProfile.iHosPhoneNumber" | translate }} -->
                    <span class="callUsPGG">{{ "doctorProfile.callOn" | translate }}</span>
                    <span class="callUsP">{{ "doctorProfile.iHosPhoneNumberAlone" | translate }}</span>
                    <span class="callUsPGG">{{ "doctorProfile.callOn2" | translate }}</span>
                  </p>
                </div>

              </div>
            </div>
          </div>

          <!-- <div class="row">
            <ul class="uiIcons">
              <i *ngIf="doctorDetails?.hasClinicServices"><img matTooltip="Clinic Visit" class="service-icon"
                  src="assets/img/navbar/clinicGreen.png" alt="" /></i>
              <i *ngIf="!doctorDetails?.hasClinicServices"><img matTooltip="Clinic Visit" class="service-icon"
                  src="assets/img/navbar/clinicGrey.png" alt="" /></i>

              <i *ngIf="doctorDetails?.hasVideoServices" class="mx-3"><img matTooltip="Online Consult"
                  class="service-icon" src="assets/img/navbar/onlineGreen.png" alt="" /></i>
              <i *ngIf="!doctorDetails?.hasVideoServices" class="mx-3"><img matTooltip="Online Consult"
                  class="service-icon" src="assets/img/navbar/onlineGrey.png" alt="" /></i>

              <i *ngIf="doctorDetails?.hasVisitServies"><img matTooltip="Home Visit" class="service-icon"
                  src="assets/img/navbar/home-green.png" alt="" /></i>
              <i *ngIf="!doctorDetails?.hasVisitServies"><img matTooltip="Home Visit" class="service-icon"
                  src="assets/img/navbar/home-grey.png" alt="" /></i>
            </ul>
          </div> -->

          <div class="row">
            <div class="px-3">
              <button (click)="selectedButton = 'info'" [class.selectedN]="selectedButton == 'info'"
                class="btn sharedBtn mx-1 mb-3  justify-content-center align-items-center">
                <p class="d-flex justify-content-center align-items-center m-0">
                  <span class="mFont">{{ 'social.info' | translate }}</span>
                </p>
              </button>

              <button (click)="selectedButton = 'community'" [class.selectedN]="selectedButton == 'community'"
                class="btn sharedBtn mx-1 mb-3  justify-content-center align-items-center">
                <p class="d-flex justify-content-center align-items-center m-0">
                  <span class="mFont">{{ 'social.myCommAct' | translate }}</span>
                </p>
              </button>
            </div>
          </div>

          <div *ngIf="selectedButton == 'info'" class="row" data-aos="fade-in" data-aos-duration="800">
            <div class="col-12">
              <agm-map class="google-img" [zoom]="14" [latitude]="doctorDetails?.latitude"
                [longitude]="doctorDetails?.longitude">
                <agm-marker [latitude]="doctorDetails?.latitude" [longitude]="doctorDetails?.longitude"
                  [markerDraggable]="true"></agm-marker>
              </agm-map>
            </div>
          </div>

          <div *ngIf="selectedButton == 'community'" class="row mb-3" data-aos="fade-in" data-aos-duration="800">
            <div class="px-3">
              <button [disabled]="app?.isLoading" (click)="selectedButtonSub = 'post'"
                (click)="switchBtn(selectedButtonSub)" [class.selectedN]="selectedButtonSub == 'post'"
                class="btn sharedBtnSub mx-1  justify-content-center align-items-center">
                <p class="d-flex justify-content-center align-items-center m-0">
                  <span class="mFont">{{ 'social.posts' | translate }}</span>
                </p>
              </button>

              <button [disabled]="app?.isLoading" (click)="selectedButtonSub = 'photos'"
                (click)="switchBtn(selectedButtonSub)" [class.selectedN]="selectedButtonSub == 'photos'"
                class="btn sharedBtnSub mx-1  justify-content-center align-items-center">
                <p class="d-flex justify-content-center align-items-center m-0">
                  <span class="mFont">{{ 'social.photos' | translate }}</span>
                </p>
              </button>

              <button [disabled]="app?.isLoading" (click)="selectedButtonSub = 'vids'"
                (click)="switchBtn(selectedButtonSub)" [class.selectedN]="selectedButtonSub == 'vids'"
                class="btn sharedBtnSub mx-1  justify-content-center align-items-center">
                <p class="d-flex justify-content-center align-items-center m-0">
                  <span class="mFont">{{ 'social.vids' | translate }}</span>
                </p>
              </button>
            </div>
          </div>

          <!-- feeds -->
          <div *ngIf="selectedButton == 'community'">
            <div class="px-3 mb-5" *ngFor="let post of Posts;let i = index" data-aos="fade-up" data-aos-duration="800">

              <!-- Post Header -->
              <div class="d-flex justify-content-between">

                <div class="d-flex">
                  <app-img-loader [className]="'creatorPost'" [src]="post?.creatorPicture"></app-img-loader>
                  <div class="mx-2 d-flex align-items-start">
                    <div>
                      <p class="m-0 posterName">{{post?.creatorName | splitStringToArEn}}</p>
                      <p class="m-0 posterSpech">{{post?.creatorSpeciality | splitStringToArEn}}</p>
                      <p class="m-0 posterSpech">{{post?.createdAt | relativeTime:app?.languageCode}}</p>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-start">
                  <!-- <p class="sponsP mx-2 m-0" *ngIf="post?.isPromoted">{{ 'social.promoted' |
                    translate }}</p> -->
                  <mat-icon *ngIf="this.app.getUserData()" (click)="editPostPopUp(post?.postId,post?.isMyPost)"
                    class="threeDotsColor pointer">more_vert</mat-icon>
                </div>

              </div>
              <!-- Post Header -->

              <!-- Post Content -->
              <div class="my-2">

                <p class="postContentP my-2" [ngClass]="post?.textDirection == 'ltr' ? 'ltr1' : 'rtl1'">
                  <span *ngIf="post?.postText?.length < 400">{{post?.postText}}</span>
                  <span *ngIf="post?.postText?.length >= 400">
                      <span *ngIf="!post?.postTextLengthMoreThan400 || post?.postTextLengthMoreThan400 == false">
                          {{post?.postText.slice(0, 400)}}<span class="text-primary mx-2 pointer" (click)="this?.Posts[i].postTextLengthMoreThan400 = true">{{ 'social.showMore2' | translate }}</span>
                      </span>
                      <span *ngIf="post?.postTextLengthMoreThan400 == true">{{post?.postText}}</span>
                  </span>
              </p>

                <div *ngIf="post?.postMedia">

                  <div *ngIf="post?.postMedia[0]?.mediaType == 1">
                    <div *ngIf="post?.postMedia?.length == 1">
                      <!-- <img class="postImg" [src]="post?.postMedia[0]?.mediaFilePath" alt=""> -->
                      <app-img-loader (click)="postDetailsPopUp(post?.postId,null)" class="XYcenter"
                        [className]="'postImg'" [src]="post?.postMedia[0]?.mediaFilePath"></app-img-loader>
                    </div>

                    <div *ngIf="post?.postMedia?.length == 2">
                      <div class="row">
                        <div *ngFor="let media of post?.postMedia; let i = index" class="col-6">
                          <!-- <img class="postImg" [src]="media?.mediaFilePath" alt=""> -->
                          <app-img-loader [className]="'posImg2'" (click)="postDetailsPopUp(post?.postId,i)"
                            class="XYcenter" [src]="media?.mediaFilePath"></app-img-loader>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="post?.postMedia?.length == 3">
                      <div class="row mb-2">
                        <app-img-loader (click)="postDetailsPopUp(post?.postId,null)" class="XYcenter"
                          [className]="'postImg'" [src]="post?.postMedia[0]?.mediaFilePath"></app-img-loader>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <app-img-loader (click)="postDetailsPopUp(post?.postId,1)" class="XYcenter"
                            [className]="'posImg3'" [src]="post?.postMedia[1]?.mediaFilePath"></app-img-loader>
                        </div>
                        <div class="col-6">
                          <app-img-loader (click)="postDetailsPopUp(post?.postId,2)" class="XYcenter"
                            [className]="'posImg3'" [src]="post?.postMedia[2]?.mediaFilePath"></app-img-loader>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="post?.postMedia?.length > 3">
                      <div class="row mb-2">
                        <!-- <img class="postImg" [src]="post?.postMedia[0]?.mediaFilePath" alt=""> -->
                        <app-img-loader (click)="postDetailsPopUp(post?.postId,null)" class="XYcenter"
                          [className]="'postImg'" [src]="post?.postMedia[0]?.mediaFilePath"></app-img-loader>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          <app-img-loader (click)="postDetailsPopUp(post?.postId,1)" class="XYcenter"
                            [className]="'postSubImg'" [src]="post?.postMedia[1]?.mediaFilePath"></app-img-loader>
                        </div>
                        <div class="col-4">
                          <app-img-loader (click)="postDetailsPopUp(post?.postId,2)" class="XYcenter"
                            [className]="'postSubImg'" [src]="post?.postMedia[2]?.mediaFilePath"></app-img-loader>
                        </div>
                        <div class="col-4" (click)="postDetailsPopUp(post?.postId,null)">
                          <div class="h-100 w-100 seeMoreBox">
                            <p class="mb-0 moreThan3P">+{{post?.postMedia?.length - 3}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="post?.postMedia[0]?.mediaType == 2">
                    <div>
                      <video width="100%" class="videoCom" controls>
                        <source [src]="app.getImageFile(post?.postMedia[0]?.mediaFilePath)" type="video/mp4">
                      </video>
                    </div>
                  </div>
                  <div *ngIf="post?.postMedia[0]?.mediaType == 3">
                    <div class="card pointer" (click)="urlClicked(post?.postMedia[0]?.mediaFilePath)">

                      <img loading="lazy" [src]="post?.postMedia[0]?.urlImage">


                      <span class="p-3 UrlDesc"> {{post?.postMedia[0]?.urlDescription}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Post Content -->

              <!-- post footer -->
              <div class="justify-content-between d-flex">
                <div>
                  <div class="inline-block">
                    <div class="d-flex pointer">
                      <mat-icon class="favColor like-icon" [ngClass]="{'liked': post?.iLikedPost}"
                        (click)="likeDislikePost(post?.postId,post?.iLikedPost,i)">{{post?.iLikedPost
                        ?
                        'favorite' :'favorite_outlined'}}</mat-icon>
                      <p class="m-0 favNumbers  mx-1 d-flex align-items-center"
                        (click)="likesPopUp(post?.postId,post?.likesCount,'post')">
                        {{post?.likesCount| likeCount}}</p>
                    </div>
                  </div>

                  <div class="inline-block">
                    <div class="d-flex pointer mx-2" (click)="postDetailsPopUp(post?.postId,null)">
                      <mat-icon class="commentsColor">chat_bubble_outlined</mat-icon>
                      <p class="m-0 favNumbers mx-1 d-flex align-items-center">
                        {{post?.commentsCount}}</p>
                    </div>
                  </div>
                  <!-- *ngIf="post?.isMyPost == true" -->
                  <div class="inline-block">
                    <div class="d-flex pointer" (click)="chartPopUp(post?.postId,post?.isMyPost)">
                      <mat-icon class="barColor">analytics_outlined</mat-icon>
                      <p class="m-0 favNumbers mx-1 d-flex align-items-center">
                        {{post?.reachCount}}
                      </p>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="d-flex pointer" (click)="arrowPopUp(post?.postId)">
                    <span class="dotCirIconArrow"><mat-icon class="arrowIcons">link</mat-icon></span>
                  </div>
                </div>
              </div>


              <!-- post footer -->
            </div>
            <div class="px-3" data-aos="fade-up" data-aos-duration="800">
              <p *ngIf="Posts?.length == 0 && !app.isLoading" class="activityP">{{ 'social.noPosts' |
                translate }}</p>
              <button *ngIf="Posts?.length < totalResult && !app.isLoading" class="btn selectedN"
                (click)="loadMorePosts()">{{ 'social.loadMore' | translate }}</button>
            </div>
          </div>
          <!-- feeds -->

        </div>
      </div>

      <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5" data-aos="fade-up" data-aos-duration="800">
        <div class="shadow-boxx card p-3">
          <div class="row">


            <div class="col-12">
              <!-- <div *ngIf="hasMoreThanOneService" class="row">
                <div class="col-12">
                  <h3>{{ "doctorProfile.PickAServiceFor" | translate }}</h3>
                  <mat-form-field class="w-100" appearance="fill">
                    <mat-label>{{
                      "doctorProfile.MedicalServices" | translate
                      }}</mat-label>
                    <mat-select (selectionChange)="serviceDropDown($event.value)">
                      <mat-option *ngFor="let Medicalservice of medicalServices" [value]="Medicalservice">
                        {{ Medicalservice.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div> -->

              <!-- <div class="col-12 mb-3">
                <button [disabled]="!isServiceSelected"
                  *ngIf="this.app.getUserData() && !this?.app?.isContributor && !this?.app?.IsSocialMediaManager"
                  (click)="
                      getMedicalServiceByClassification()
                    " class="btn submit-btn col-12">
                  {{ "doctorProfile.Book Appointment" | translate }}
                </button>

                <button *ngIf="!this.app.getUserData()" matTooltip="You must be logged in"
                  class="btn submit-btn col-12 btn-dis" (click)="notLoggedInDialog()">
                  {{ "doctorProfile.Book Appointment" | translate }}
                </button>
              </div> -->

              <p class="m-0 chooseP text-center my-3">{{'SearchDoctor.chooseTheTime' | translate}}</p>

              <div class="d-flex justify-content-between mb-3 bigBoxIcons">


                  <button [disabled]="!doctorDetails?.hasClinicServices" class="SharedLoButton"
                  [matTooltip]="doctorDetails?.hasClinicServices == false ? notAvailableText : ''"
                    (click)="switchOnClick('clinic',3)"
                    [class.selectedClassification]="selectedButtonAppointment == 'clinic'">
                    <img class="threeIcon"
                      [src]="selectedButtonAppointment == 'clinic' ? 'assets/img/newIcons/clinic.png' : 'assets/img/selected/unselectedClinic.svg'"
                      alt="" />
                      <!-- [ngClass]="doctorDetails?.hasClinicServices == true ? 'sharedTextBtns' : 'sharedTextBtnsNot'" -->
                    <p class="threeP">
                      {{'SearchDoctor.clinicVisit' | translate}}</p>
                  </button>
  
                  <button [disabled]="!doctorDetails?.hasVideoServices"
                  [matTooltip]="doctorDetails?.hasVideoServices == false ? notAvailableText : ''"
                    class="SharedLoButton mx-5Middle" (click)="switchOnClick('online',2)"
                    [class.selectedClassification]="selectedButtonAppointment == 'online'">
                    <img class="threeIcon"
                      [src]="selectedButtonAppointment == 'online' ? 'assets/img/newIcons/online.png' : 'assets/img/selected/unselectedOnline.svg'"
                      alt="" />
                    <p class="threeP">
                      {{'SearchDoctor.onlineConsult' | translate}}</p>
                  </button>
  
                  <button [disabled]="!doctorDetails?.hasVisitServies" class="SharedLoButton"
                  [matTooltip]="doctorDetails?.hasVisitServies == false ? notAvailableText : ''"
                    (click)="switchOnClick('home',1)"
                    [class.selectedClassification]="selectedButtonAppointment == 'home'">
                    <img class="threeIcon"
                      [src]="selectedButtonAppointment == 'home' ? 'assets/img/newIcons/home.png' : 'assets/img/selected/unselectedHome.svg'"
                      alt="" />
                    <p class="threeP">
                      {{'SearchDoctor.homeVisit' |
                      translate}}</p>
                  </button>
                


              </div>

              <p *ngIf="selectedButtonAppointment == 'clinic' || selectedButtonAppointment == 'online'"
                class="m-0 d-flex justify-content-center align-items-center f90">
                <mat-icon class="material-symbols-outlined text-blue mx-1">error</mat-icon>
                <!-- <i class="fa fa-exclamation mx-9 text-blue"></i> -->
                <!-- <mat-icon class="material-symbols-outlined expl-icon">error</mat-icon> -->
                <span class="gray-t">{{
                  "doctorProfile.Feesforthisdoctor" | translate
                  }}</span>
                <span class="text-blue font-bold">
                  {{ doctorDetails?.price }}
                  {{ "doctorProfile.JD" | translate }}</span>
                <span class="gray-t">
                  ({{
                  "SearchDoctor.Doesnotincludeprocedures" | translate
                  }})</span>
              </p>

              <div class="row">

                <!-- <h3 *ngIf="!hasMoreThanOneService">{{ "NavBar.availableTimings" | translate }}</h3> -->

                <!-- Schedule Content -->
                <div class="schedule-cont">
                  <div class="row">
                    <div class="col-md-12"
                      *ngIf="selectedButtonAppointment == 'clinic' || selectedButtonAppointment == 'online'"
                      data-aos="fade-in" data-aos-duration="1200">
                      <!-- Time Slot -->
                      <div class="time-slot" *ngIf="Week?.length > 0">
                        <ul class="clearfix">
                          <ngx-slick-carousel class="col-lg-2 col-md-4 d-flex aos w-100" #slickModal="slick-carousel"
                            [ngClass]="this.app?.getUserLanguage() == 'en' ? 'EnCar' : 'ArCar'"
                            [config]="slideConfigureForDoctor">
                            <div *ngFor="let item of Week ; let i = index">
                              <!-- <span>{{item.fullDate}}</span> -->
                              <!-- [ngClass]="{'today-bg' : day == Week[0]}" -->
                              <div class="text-center">
                                <p class="schDayP"> {{ item?.dayName }} <span class="d-inli"
                                    *ngIf="item?.date == todayDate">{{'doctorProfile.Today' |translate }}</span> <span
                                    class="d-inli" *ngIf="item?.date == todayDate + 1">{{'doctorProfile.tmrw' |translate
                                    }}</span></p>
                                <!-- <span class="d-inli" *ngIf="day == Week[0]">{{'doctorProfile.Today' |translate }}</span> -->
                                <p class="schDateP">{{ item.date }} / {{ item?.month }}</p>
                              </div>
                              <hr>

                              <button #myButton href="#modal_form" data-bs-toggle="modal"
                                style="visibility:hidden;opacity: 0;display: none;">
                                hide
                              </button>

                              <li class="w-100" ngxSlickItem>
                                <a *ngIf="item?.Times && item?.Times?.hasSlots == true">
                                  <!-- href="#modal_form" data-bs-toggle="modal" -->
                                  <a class="slotTiming timing" *ngFor="let week of item?.Times?.slots"
                                    (click)="selectTimeSlotFun(week)">
                                    <span> {{ week?.from | date: 'shortTime' }} - {{ week?.to |
                                      date:
                                      'shortTime' }} </span>
                                  </a>
                                </a>
                                <div class="text-center"
                                  *ngIf="item?.Times?.hasSlots == false || item?.Times?.slots.length == 0">
                                  <p>_</p>
                                  <p>_</p>
                                  <p>_</p>
                                  <p>_</p>
                                  <p>_</p>
                                  <p>_</p>
                                </div>
                              </li>

                            </div>
                          </ngx-slick-carousel>
                        </ul>
                      </div>
                      <!-- /Time Slot -->
                    </div>
                    <div class="col-md-12 text-center" *ngIf="selectedButtonAppointment == 'home'" data-aos="fade-in"
                      data-aos-duration="1200">
                      <div class="col-12 mb-3">
                        <p class="m-0">
                          <i class="fa fa-phone mx-10 text-blue callIcon"></i>
                          <!-- +({{doctorDetails?.mobileNumber |slice:0:3}})
                            0{{doctorDetails?.mobileNumber |
                            slice:3:doctorDetails?.mobileNumber.length}} -->
                          <!-- {{ "doctorProfile.iHosPhoneNumber" | translate }} -->
                          <span class="callUsPGG">{{ "doctorProfile.callOn" | translate }}</span>
                          <span class="callUsP">{{ "doctorProfile.iHosPhoneNumberAlone" | translate }}</span>
                          <span class="callUsPGG">{{ "doctorProfile.callOn3" | translate }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Schedule Content -->
              </div>

            </div>

          </div>
        </div>
      </div>

    </div>


    <!-- Doctor Details Tab -->
    <div *ngIf="selectedButton == 'info'" class="card shadow-boxx" data-aos="fade-up" data-aos-duration="800">
      <div class="card-body p-t-16">
        <!-- <nav class="user-tabs mb-4">
					<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
						<li class="nav-item">
							<a class="nav-link active" href="#doc_overview" data-bs-toggle="tab">{{
								'SearchDoctor.Overview' | translate }}</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" href="#doc_locations" data-bs-toggle="tab">{{
								'SearchDoctor.Locations' | translate }}</a>
						</li>
					</ul>
				</nav> -->

        <!-- Tab Content -->
        <div class="tab-content pt-0">
          <!-- Overview Content -->
          <div role="tabpanel" id="doc_overview" class="tab-pane fade show active">
            <!-- About Details -->
            <div *ngIf="doctorDetails?.about" class="widget about-widget">
              <h4 *ngIf="this.app?.getUserLanguage() == 'en'" class="widget-title text-blue f-weight-f-17">
                {{ "doctorProfile.overView" | translate
                }}{{ doctorDetails?.fullName | splitStringToArEn }}
              </h4>
              <h4 *ngIf="this.app?.getUserLanguage() == 'ar'" class="widget-title text-blue f-weight-f-17">
                {{ "doctorProfile.overView" | translate }}
                {{ doctorDetails?.fullName | splitStringToArEn }}
              </h4>

              <p class="gray-t">
                {{doctorDetails?.about | customSplit}}
              </p>
            </div>
            <!-- /About Details -->
            <div class="row">
              <div class="col-12">
                <!-- Education Details -->
                <div *ngIf="doctorDetails?.hcpDegrees" class="widget education-widget">
                  <h4 class="widget-title text-blue f-weight-f-17">
                    {{ "SearchDoctor.Education" | translate }}
                  </h4>
                  <!-- <div class="experience-box">
                    <ul class="experience-list">
                      <li *ngFor="let exper of doctorDetails?.hcpDegrees">
                        <div class="experience-user">
                          <div class="before-circle"></div>
                        </div>
                        <div class="experience-content">
                          <div class="timeline-content">
                            <a class="name text-blue">{{ exper.university }}</a>
                            <div>{{ exper.fieldOfStudy }}</div>
                            <span *ngIf="exper.graduationYear != 0" class="time">{{ exper.graduationYear }}</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div> -->

                  <div class="row" *ngIf="doctorDetails?.hasMoreThan4hcpDegrees == true">
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-5"
                      *ngFor="let exper of doctorDetails?.hcpDegrees | slice :0:5"
                      [ngClass]="this.app?.getUserLanguage() == 'en' ? 'borderEn' : 'borderAr'">
                      <p class="insuranceEn m-0">{{exper?.university}}</p>
                      <p class="insuranceAr m-0">{{ exper?.fieldOfStudy }}</p>
                      <p *ngIf="exper.graduationYear != 0" class="insuranceAr m-0">{{ exper?.graduationYear }}</p>
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-5">
                      <button (click)="doctorDetails.hasMoreThan4hcpDegrees = false"
                        class="btn viewMoreBtn">{{'Home.ViewMore'|translate}}</button>
                    </div>
                  </div>

                  <div class="row" *ngIf="!doctorDetails?.hasMoreThan4hcpDegrees">
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-5"
                      *ngFor="let exper of doctorDetails?.hcpDegrees"
                      [ngClass]="this.app?.getUserLanguage() == 'en' ? 'borderEn' : 'borderAr'">
                      <p class="insuranceEn m-0">{{exper?.university}}</p>
                      <p class="insuranceAr m-0">{{ exper?.fieldOfStudy }}</p>
                      <p *ngIf="exper.graduationYear != 0" class="insuranceAr m-0">{{ exper?.graduationYear }}</p>
                    </div>

                    <div *ngIf="doctorDetails?.hasMoreThan4hcpDegrees == false"
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-5">
                      <button (click)="doctorDetails.hasMoreThan4hcpDegrees = true"
                        class="btn viewMoreBtn">{{'Home.ViewLess'|translate}}</button>
                    </div>
                  </div>
                </div>
                <!-- /Education Details -->

                <!-- Experience Details -->
                <div *ngIf="doctorDetails?.companies" class="widget experience-widget">
                  <h4 class="widget-title text-blue f-weight-f-17">
                    {{ "SearchDoctor.Work & Experience" | translate }}
                  </h4>

                  <!-- <div class="experience-box">
                    <ul class="experience-list">
                      <li *ngFor="let work of doctorDetails?.companies">
                        <div class="experience-user">
                          <div class="before-circle"></div>
                        </div>
                        <div class="experience-content">
                          <div class="timeline-content">
                            <a class="name text-blue">{{work?.englishName}}</a>
                            <span class="time">{{ work?.arabicName }}</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div> -->

                  <div class="row" *ngIf="doctorDetails?.hasMoreThan4Insurances == true">
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-5 "
                      *ngFor="let work of doctorDetails?.companies | slice :0:5"
                      [ngClass]="this.app?.getUserLanguage() == 'en' ? 'borderEn' : 'borderAr'">
                      <p class="insuranceEn m-0">{{work?.englishName}}</p>
                      <p class="insuranceAr m-0">{{ work?.arabicName }}</p>
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-5">
                      <button (click)="doctorDetails.hasMoreThan4Insurances = false"
                        class="btn viewMoreBtn">{{'Home.ViewMore'|translate}}</button>
                    </div>
                  </div>

                  <div class="row" *ngIf="!doctorDetails?.hasMoreThan4Insurances">
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-5 "
                      *ngFor="let work of doctorDetails?.companies"
                      [ngClass]="this.app?.getUserLanguage() == 'en' ? 'borderEn' : 'borderAr'">
                      <p class="insuranceEn m-0">{{work?.englishName}}</p>
                      <p class="insuranceAr m-0">{{ work?.arabicName }}</p>
                    </div>

                    <div *ngIf="doctorDetails?.hasMoreThan4Insurances == false"
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-5">
                      <button (click)="doctorDetails.hasMoreThan4Insurances = true"
                        class="btn viewMoreBtn">{{'Home.ViewLess'|translate}}</button>
                    </div>
                  </div>

                </div>
                <!-- /Experience Details -->

                <!-- Services List -->
                <!-- <div class="service-list">
									<h4 class="text-blue f-weight-f-17">{{ 'SearchDoctor.Medical Services' | translate }}</h4>
									<ul class="clearfix">
										<li *ngFor="let srv of doctorDetails?.medicalServices">{{srv.name}}</li>
									</ul>
								</div> -->
              </div>
            </div>
          </div>
          <!-- /Overview Content -->

        </div>
      </div>
    </div>
    <!-- /Doctor Details Tab -->
  </div>

  <!-- /Doctor Widget -->
</div>

<!-- Booking Modal-->
<div *ngIf="app?.isPlatformBrowserVar" id="modal_form" class="modal fade custom-modal" tabindex="-1" role="dialog"
  aria-modal="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <form [formGroup]="form" (ngSubmit)="submit()" action="#" enctype="multipart/form-data" autocomplete="off"
        method="post">
        <div class="modal-header">
          <h5 class="modal-title m-0">{{ 'booking.Visit Details' | translate }}</h5>
          <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
        </div>
        <div class="modal-body row">

          <!-- <div class="form-group">
						<label class="control-label mb-10"> {{ 'Patient.Addnewmember' | translate }} <span
								class="text-danger">*</span></label>
						<input formControlName="Name" type="text" class="form-control">
					</div> -->

          <div class="form-group col-12">
            <label class="control-label mb-10">{{ 'booking.Visit For Who' | translate }} </label>
            <select formControlName="RelativeId" class="form-control form-select">
              <option selected [value]="0"> {{ 'booking.me' | translate }}</option>
              <option *ngFor="let relative of relatives" [value]="relative.id">
                {{relative.name}}
              </option>
            </select>
          </div>

          <div class="form-group col-12" *ngIf="this?.symptoms?.length > 0">
            <label class="control-label mb-10">{{ 'booking.Symptoms' | translate }}</label>
            <select formControlName="Symptoms" class="form-control form-select" multiple>
              <option *ngFor="let symptom of symptoms" [value]="symptom.id">
                {{symptom.name}}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label class="control-label mb-10"> {{ 'booking.PromoCode' | translate }} <span
                class="text-danger"></span></label>
            <input formControlName="PromoCodeStringNotMapped" type="text" class="form-control">
          </div>

          <div class="form-group col-12">
            <mat-label> {{ 'booking.comment' | translate }} </mat-label>
            <textarea class="h-160 form-control" autocomplete="off" type="text" formControlName="Comment"
              cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
          </div>

          <div class="mb-3">
            <p for="">{{ 'booking.Add Images' | translate }}</p>
            <input #fileUploaderControl type='file' (change)="readUrl($event)" accept="image/*" multiple
              style="display: none;" />

            <div [dir]="this.app.getUserDire()" (click)="fileUploaderControl.click()"
              class="w-100 box-upload d-flex cur-pointer">
              <span>
                <mat-icon class="blue-main mx-2">photo_camera</mat-icon>
              </span>
              <span class="pt-cut"><span class="sub-box-p">{{ 'appointments.Clickhere' | translate}}</span></span>
            </div>
          </div>

          <div class="row col-12 justify-content-center">
            <div class="col-3" *ngFor="let image of imagesToPreview">
              <img loading="lazy" class="attachment-img w-webFill" [src]="image.image" />
              <button class="btns btn btn-primary w-webFill" (click)="removeFromImages(image)" mat-raised-button
                type="button">{{ 'booking.Remove' | translate }}</button>
            </div>
          </div>
          <!-- <div class="form-group col-12">
						<div class="row">
							<h5 class="modal-title m-0">Payment Details</h5>
							<div class="col-6">
								<p>asd</p>
								<p>asd</p>
							</div>
							<div class="col-6">
								<p>asd</p>
								<p>asd</p>
							</div>
						</div>
					</div> -->

          <!-- <div class="form-group">
						<label class="control-label mb-10">{{ 'Patient.DateOfBirth' | translate }}</label>
						<input formControlName="BirthDate" type="date" class="form-control">
					</div> -->

        </div>
        <div class="row pay-div">
          <!-- <h5 class="modal-title m-0 mb-2">Payment Details</h5> -->
          <div class="col-12">
            <div class="row">
              <div class="col-3">
                <p class="text-muted">{{ 'booking.date' | translate }}</p>
                <p><span class="price-font">{{selectedTimeSlot?.from | slice :0:10}}</span></p>
              </div>
              <div class="col-3">
                <p class="text-muted">{{ 'booking.time' | translate }}</p>
                <p><span class="price-font">{{selectedTimeSlot?.from | slice :11:16}}</span></p>
              </div>
              <div class="col-2">
                <p class="text-muted">{{ 'booking.price' | translate }}</p>
                <p>
                  <span *ngIf="serviceSelected?.price > 0" class="price-font">{{
                    serviceSelected?.price }}{{'doctorProfile.JD'|translate}}</span>
                  <span *ngIf="serviceSelected?.price == 0" class="price-font">{{ 'appointments.Free'
                    | translate }}</span>
                </p>

              </div>
              <div class="col-4">
                <p class="text-muted">{{ 'booking.paymethod' | translate }}</p>
                <p *ngIf="isPaymentOnline"><span class="price-font">{{ 'booking.OnlineVisa' | translate
                    }} </span></p>
                <p *ngIf="!isPaymentOnline"><span class="price-font">{{ 'booking.OnArrive' | translate
                    }} </span></p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer text-right">
          <button *ngIf="isPaymentOnline" type="submit" data-bs-dismiss="modal" class="btn blue-btn-heavy submit-btn">
            {{'booking.Proceed To Pay' | translate }}</button>
          <button *ngIf="!isPaymentOnline" type="submit" data-bs-dismiss="modal" class="btn blue-btn-heavy submit-btn">
            {{ 'booking.bookNow' | translate }}</button>
        </div>
      </form>
      <!-- <button (click)="test();">test</button> -->
    </div>
  </div>
</div>
<!-- /Booking Modal-->

<!-- <SSR> -->
<div *ngIf="app?.isPlatformServerVar"
  style="display: none !important;visibility:hidden !important;opacity: 0 !important;">
  <h1 *ngIf="textSectionTitle != null">{{textSectionTitle}}</h1>
  <img title="{{doctorDetails?.fullName}} - {{ doctorDetails?.speciality }}"
    [src]="app.getUserImage2(doctorDetails?.picture)"
    alt="{{doctorDetails?.fullName}} - {{ doctorDetails?.speciality }}" />
  <h2>
    {{ doctorDetails?.fullName }}
  </h2>
  <h5>
    {{ doctorDetails?.speciality }}
  </h5>
  <div>
    <span *ngFor="let docSRV of doctorDetails?.medicalServices">{{
      docSRV.name }}</span>
  </div>
  <p>
    {{ doctorDetails?.location?.parentName }}
    {{ doctorDetails?.location?.name }}
    {{ doctorDetails?.address }}
  </p>
  <span>
    {{ doctorDetails?.price }}
    {{ "doctorProfile.JD" | translate }}</span>
  <p>
    {{ doctorDetails?.rate }}
  </p>
  <p *ngIf="doctorDetails?.about">
    {{doctorDetails?.about}}
  </p>

  <div *ngIf="doctorDetails?.hcpDegrees">
    <li *ngFor="let exper of doctorDetails?.hcpDegrees">
      <p>{{ exper.university }}</p>
      <p>{{ exper.fieldOfStudy }}</p>
      <span *ngIf="exper.graduationYear != 0">{{ exper.graduationYear }}</span>
    </li>
  </div>

  <div *ngIf="doctorDetails?.companies">
    <li *ngFor="let work of doctorDetails?.companies">
      <a>{{work?.englishName}}</a>
      <span>{{ work?.arabicName }}</span>
    </li>
  </div>

  <div *ngFor="let post of PostsForSSR">
    <a [routerLink]=" '/' + app?.languageCode +'/Tebgram/post/' + post?.postId"></a>
    <h2> {{ post?.creatorName }}</h2>
    <h4> {{ post?.creatorSpeciality }}</h4>
    <p> {{ post?.createdAt }}</p>
    <h2> {{ post?.postText }}</h2>
  </div>

</div>
<!-- </SSR> -->